export default __webpack_public_path__ + "static/thailand-c7d8a8bc008110bc04c85de5ccaf6ad5.svg";